export const KEY_NAME_MAP: Record<string, string> = {
  ' ': 'Space',
  Escape: 'esc',
  ArrowUp: '↑',
  ArrowDown: '↓',
  ArrowLeft: '←',
  ArrowRight: '→',
};

export function isMac() {
  return window.navigator.platform.toLowerCase().includes('mac');
}

export function getCtrlKeyIndicator() {
  return isMac() ? '⌘' : 'ctrl +';
}

export function hasActivated(event: KeyboardEvent, hotkey: string, ctrlKey?: boolean) {
  if (event.key.toLowerCase() !== hotkey.toLowerCase()) {
    return false;
  }

  if (isMac()) {
    if (ctrlKey && !event.metaKey) {
      return false;
    }
  } else if (ctrlKey && !event.ctrlKey) {
    return false;
  }

  return true;
}
